import React, { useState, useEffect } from "react";
import deleteIcon from "../../images/del.svg";
import { useDispatch, useSelector } from "react-redux";
import { returnItem } from "../inventory/itemsSlice";
import { saleReturn } from "./httpCalls";
import { Autocomplete, Box, Grid } from "@mui/material";
import { Button, Stack, styled, TextField, Typography } from "@mui/material";
import { toEditItem, toRemoveItem, toRemoveItems } from "./saleReturnSlice";
import Loader from "../components/Loader";
import { getLedgersNames } from "../ledgers/ledgersNamesSlice";

const TotalBox = styled(Grid)({
  backgroundColor: "white",
  borderRadius: "20px",
  margin: "0px 5px",
  padding: "15px 10px",
  boxShadow: "0px 3px 6px #c2c1c1",
  color: "#757575",
  marginTop: "50px",
});

function SaleReturn() {
  const dispatch = useDispatch();
  const { ledgersNames } = useSelector((state) => state.ledgersNames);
  const { items } = useSelector((state) => state.saleReturn);
  const [state, setState] = useState({
    items: [],
    loading: false,
    Total: 0,
    selectedLedger: "",
  });
  useEffect(() => {
    if (ledgersNames.length == 0) {
      dispatch(getLedgersNames());
    }
  }, []);

  const totalPrice = () => {
    let totalAmount = 0;
    items.forEach((item) => {
      let qty = item.saleReturnQuantity ? item.saleReturnQuantity : 1;
      totalAmount =
        parseFloat(totalAmount) + parseFloat(qty) * parseFloat(item.price);
    });
    return totalAmount;
  };

  const handleDelete = (index) => {
    dispatch(toRemoveItem(index));
  };

  const handleReturn = async () => {
    let copyItems = JSON.parse(JSON.stringify(items));
    setState((pre) => ({ ...pre, loading: true }));
    copyItems.forEach((item) => {
      let qty = item.saleReturnQuantity ? parseInt(item.saleReturnQuantity) : 1;
      dispatch(returnItem({ _id: item._id, qty: qty }));
    });
    dispatch(toRemoveItems());
    await saleReturn(items, state.selectedLedger?._id);
    setState((pre) => ({ ...pre, selectedLedger: "", loading: false }));
  };

  const handleChange = (e, index) => {
    let { name, value } = e.target;
    dispatch(toEditItem({ index: index, key: name, value: value }));
  };

  const handleInput = (e, val) => {
    setState((pre) => ({ ...pre, selectedLedger: val }));
  };

  return (
    <Box sx={{ mt: 3, mt: { md: "2px", xs: "40px" } }}>
      <Typography
        variant="h4"
        sx={{ color: "#4eaf51", fontSize: { md: "2.125rem", xs: "16px" } }}
      >
        Ledger Selection
      </Typography>

      <Autocomplete
        size="small"
        sx={{ mb: 2, mt: 2, background: "white" }}
        value={state?.selectedLedger?.name}
        onChange={(e, val) => {
          handleInput(e, val);
        }}
        getOptionLabel={(option) => option.name || ""}
        id="controllable-states-demo"
        options={ledgersNames}
        renderInput={(params) => <TextField {...params} label="Ledgers" />}
      />

      <div className="table-titles-sell-return">
        <h2 className="center regular f-8">#</h2>
        <h2 className="regular f-8">Item</h2>
        <h2 className="regular f-8">Current Qty</h2>
        <h2 className="regular f-8">Return Qty</h2>
        <h2 className="regular f-8">Unit Price</h2>
        <h2 className="regular f-8">Total Price</h2>
      </div>
      {items.map((item, i) => {
        let qty =
          item.weightType == true
            ? parseFloat(item.weight)
            : parseFloat(item.quantity);
        let saleQty = item.saleReturnQuantity ? item.saleReturnQuantity : 1;

        return (
          <div key={i} className="table-values-sell-return">
            <h3 className="center regular f-8">{i + 1}</h3>
            <h3 className=" regularf-8 ">{item.name}</h3>
            <h3 className=" regular f-8">
              {qty % 1 === 0 ? qty : qty.toFixed(3)}
            </h3>
            <Stack alignItems="flex-start" justifyContent="center">
              <input
                className="new-input-sale f-8"
                type="number"
                style={{ border: "1px solid #dcdcdc" }}
                max={qty}
                min={1}
                name="saleReturnQuantity"
                value={item.saleReturnQuantity || ""}
                onChange={(e) => handleChange(e, i)}
              />
            </Stack>
            <Stack alignItems="flex-start" justifyContent="center">
              <input
                className="new-input-sale f-8"
                style={{ border: "1px solid #dcdcdc" }}
                type="number"
                disabled
                value={item.price}
              />
            </Stack>

            <h3 className=" regular f-8" style={{ marginLeft: "10px" }}>
              {parseFloat(saleQty * item.price)}
            </h3>
            <Stack alignItems="center" justifyContent="center">
              <img
                width="20px"
                src={deleteIcon}
                alt="img"
                onClick={() => handleDelete(i)}
              />
            </Stack>
          </div>
        );
      })}

      <Grid container justifyContent="flex-end">
        <TotalBox item md={4} sm={8} xs={12}>
          <Stack direction="row" justifyContent="space-between" padding="5px">
            <Typography>Sub Total:</Typography>
            <Typography>{totalPrice()}</Typography>
          </Stack>

          <hr />
          <Stack alignItems="center" justifyContent="center" padding="5px">
            {state.loading && <Loader loading={state.loading} />}
            {!state.loading && state.selectedLedger && items && (
              <Button
                contained
                sx={{ color: "white", background: "#e82b2b !important" }}
                onClick={handleReturn}
              >
                Sale Return
              </Button>
            )}
          </Stack>
        </TotalBox>
      </Grid>
    </Box>
  );
}

export default SaleReturn;
